import React from "react";
import { useFormContext } from "react-hook-form";
import { Controller } from "react-hook-form";
import { RadioGroup, FormControlLabel, Radio, FormControl, FormLabel, FormHelperText } from "@mui/material";
import FieldLabel from "./FieldLabel";

const FormControlRadio = ({ name, label, options, required, control: controlProps, ...props }) => {
  const { control: controlContext } = useFormContext();
  const control = controlProps || controlContext;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => {
        const error = errors?.[name];
        return (
          <FormControl>
            <FormLabel>
              <FieldLabel
                label={label}
                required={required}
              />
            </FormLabel>
            <RadioGroup
              {...field}
              {...props}
            >
              {options.map((v) => (
                <FormControlLabel
                  key={v.value}
                  value={v.value}
                  control={<Radio />}
                  label={v.label}
                />
              ))}
            </RadioGroup>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
};

export default FormControlRadio;
